import { createAsyncThunk } from "@reduxjs/toolkit";
import { bffApi, type ContractDto } from "../../../../autogen/bff-api";
import { ContractState } from "../../reducers/contractReducer";
import { readSettled } from "../../untilSettled";

export const fetchSettledContract = createAsyncThunk<ContractDto, { contractId: string }>(
  "contract/fetchSettled",
  async ({ contractId }, thunk) => {
    try {
      return await readSettled(bffApi.endpoints.getContract, { contractId }, thunk);
    } catch (e) {
      return thunk.rejectWithValue(e);
    }
  },
);

export const loadContractThunk = createAsyncThunk(
  "contract/load",
  async (
    props: {
      contractId: string;
    },
    { dispatch, rejectWithValue }
  ) => {
    try {
      const contract = await dispatch(fetchSettledContract({ contractId: props.contractId })).unwrap();
      const loaded: ContractState = {
        id: contract.id,
        contract: contract as ContractState["contract"],
        lastChanged: contract.modifiedAt,
        errors: [],
      };
      return loaded;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);
